const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'เอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.description': 'อัปโหลดภาพที่ชัดเจนของด้านเอกสารทะเบียนรถที่ร้องขอ',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'ด้านหน้าของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'ถ่ายภาพด้านหน้าของเอกสารทะเบียนรถให้ชัดเจน',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'ด้านหน้าของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'ด้านหน้าของเอกสารทะเบียนรถ - ตัวอย่าง',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'ด้านหน้าของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'ด้านหลังของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'ถ่ายภาพด้านหลังของเอกสารทะเบียนรถให้ชัดเจน',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline': 'ด้านหลังของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'ด้านหลังของเอกสารทะเบียนรถ - ตัวอย่าง',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'ด้านหลังของเอกสารทะเบียนรถ',
	'vehicleRegistrationDocument.validationHeadline': 'ภาพถ่ายไม่ครบ',
	'vehicleRegistrationDocument.validationDescription': 'โปรดเพิ่มภาพถ่ายต่อไปนี้:',
	'landing.stepDescription.vehicleRegistrationDocument': 'ถ่ายภาพเอกสารทะเบียนรถ',
	'review.stepDescription.vehicleRegistrationDocument': 'เอกสารทะเบียนรถ',
	'blockedByDevice.headline': 'PolicyCheck ไม่รองรับเบราว์เซอร์เดสก์ท็อป',
	'blockedByDevice.description':
		'PolicyCheck กำลังใช้เบราว์เซอร์เดสก์ท็อป แพลตฟอร์ม PolicyCheck ดำเนินการจัดทำเอกสารกรณีต่างๆ โดยใช้อุปกรณ์เคลื่อนที่ หากต้องการดำเนินการต่อ โปรดเรียกใช้ลิงก์ PolicyCheck บนอุปกรณ์เคลื่อนที่',
	'button.accept': 'ยอมรับ',
	'button.addLater': 'เพิ่มภายหลัง',
	'button.backchangeImage': 'กลับและเปลี่ยนภาพ',
	'button.changeImage': 'เปลี่ยนรูป',
	'button.continue': 'ดำเนินการต่อ',
	'button.close': 'ปิด',
	'button.deleteImage': 'ลบรูปภาพ',
	'button.next': 'ถัดไป »',
	'button.ok': 'ตกลง',
	'button.onApproval': 'รับการคำนวณ',
	'button.onCallback': 'ได้รับบันทึกการโทรกลับ',
	'button.onExpertRequest': 'คำขอของผู้เชี่ยวชาญ',
	'button.onInsuranceExpert': 'มุ่งสู่ผู้เชี่ยวชาญด้านประกันภัย',
	'button.onLanding': 'โดยไม่ต้องขึ้นเครื่อง',
	'button.onOnboarding': 'เริ่มต้น',
	'button.onVideocall': 'วีดีโอรีวิว',
	'button.prev': 'กลับมา',
	'button.start': 'เริ่ม',
	'button.showTutorial': 'ดูบทแนะนำ',
	'completeFourAdditionalPicturesModal.description': 'กรุณาเพิ่มข้อมูลต่อไปนี้:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'ภาพถ่ายของไมล์สะสม',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'แผงควบคุม',
	'completeFourAdditionalPicturesModal.hasVINImage':
		'ภาพถ่ายพร้อมหมายเลข VIN (ตัวถัง) ที่มองเห็นได้',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'ภาพกระจกหน้ารถ',
	'completeFourAdditionalPicturesModal.headline': 'คำใบ้',
	'completeVehicleImagesModal.headline': 'คำใบ้',
	'completeVehicleImagesModal.description': 'กรุณาเพิ่มข้อมูลต่อไปนี้',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'ภาพแนวทแยงด้านหน้า-ด้านซ้าย',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'ภาพแนวทแยงด้านหน้า-ด้านขวา',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'ภาพแนวทแยงด้านหลัง-ด้านซ้าย',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'ภาพแนวทแยงด้านหลัง-ด้านขวา',
	'dataPrivacyModal.headline': 'ข้อกำหนดและเงื่อนไข',
	'dashboardMileage.dashboard.title': 'ภาพถ่ายของไมล์สะสม',
	'dashboardMileage.placeholder': 'กรอกไมล์ของรถ',
	'vehicleImages.leftFrontOverview': 'ภาพแนวทแยงด้านหน้า-ด้านซ้าย',
	'vehicleImages.leftRearOverview': 'ภาพแนวทแยงด้านหลัง-ด้านซ้าย',
	'vehicleImages.rightFrontOverview': 'ภาพแนวทแยงด้านหน้า-ด้านขวา',
	'vehicleImages.rightRearOverview': 'ภาพแนวทแยงด้านหลัง-ด้านขวา',
	'editPhoto.edit': 'เพื่อเปลี่ยน',
	'fourPerspectivesExampleModal.button.close': 'ปิด',
	'fourPerspectivesExampleModal.headline.first': 'ภาพถ่ายภาพรวมรถ - ตัวอย่าง',
	'helpModal.description':
		'คุณไม่สามารถดำเนินการใด ๆ เพิ่มเติมด้วยขั้นตอนเดียวหรือมีคำถามเกี่ยวกับการสมัคร? กรุณาติดต่อเรา! เรายินดีที่จะช่วยเหลือคุณ',
	'helpModal.headline': 'ช่วย',
	'imageRecognitionFeedback2.exemplaryPhoto': 'ตัวอย่างการถ่ายภาพ',
	'landing.aboutPolicyCheck': 'PolicyCheck คืออะไร',
	'landing.changeLang': 'หากต้องการเปลี่ยนภาษา คลิกที่นี่',
	'chooseLang.headline': 'เลือกภาษาที่คุณต้องการ',
	'landing.dataPrivacyLink': 'ในการดำเนินการต่อจากนี้แสดงว่าคุณยอมรับข้อกำหนดในการให้บริการของเรา',
	'landing.headline.policyCheck': 'ยินดีต้อนรับ',
	'landing.paragraph': 'คุณเหลืออีกสามขั้นตอนในการดำเนินการให้เสร็จสิ้น',
	'landing.termsAndConditionsLink':
		'ในการดำเนินการต่อจากนี้แสดงว่าคุณยอมรับข้อกำหนดในการให้บริการของเรา',
	'landing.termsAndConditionsLinkDescription':
		'ในการดำเนินการต่อจากนี้แสดงว่าคุณยอมรับข้อกำหนดในการให้บริการของเรา',
	'landing.stepDescription.fourAdditionalPictures': 'อัพโหลดรูปภาพ',
	'landing.stepDescription.fourDiagonalPerspectives': 'ถ่ายรูปภาพที่ต้องการ',
	'landing.stepDescription.feedback': 'ให้ข้อเสนอแนะของคุณกับเรา',
	'loader.loading': 'กำลังโหลดข้อมูล ...',
	'fourAdditionalPictures.mileage.description':
		'กรุณาถ่ายรูปไมล์ของคุณ หากรถของคุณมีจอแสดงผลดิจิตอล กรุณาถ่ายรูปไมล์ของคุณ หากรถของคุณมีจอแสดงผลดิจิตอล โปรดเปิดสวิตช์',
	'fourAdditionalPictures.mileage.enter': 'กรอกไมล์ของรถ',
	'fourAdditionalPictures.mileage.title': 'ไมล์สะสม',
	'fourAdditionalPictures.overallDashboard.description':
		'ถ่ายภาพแผงหน้าปัดรถยนต์ของรถคุณให้สมบูรณ์',
	'fourAdditionalPictures.overallDashboard.title': 'แผงหน้าปัดรถยนต์',
	'fourAdditionalPictures.title': 'รูปภาพเพิ่มเติม',
	'fourAdditionalPictures.vin.description':
		'กรุณาถ่ายรูปหมายเลข ตัวถัง ของรถคุณ คุณสามารถพบสิ่งนี้ได้ที่ซีลประตูด้านคนขับหรือที่มุมล่างซ้ายของกระจกหน้ารถ',
	'fourAdditionalPictures.vin.title': 'หมายเลข ตัวถัง ของรถ',
	'fourAdditionalPictures.windshield.description': 'โปรดถ่ายรูปกระจกหน้ารถของคุณโดยละเอียด',
	'fourAdditionalPictures.windshield.title': 'กระจกหน้ารถ',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourAdditionalPictures.vin.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',

	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'ตัวอย่างการถ่ายภาพ',

	'vehicleImages.overviewPhotos': 'ถ่ายภาพรวมของรถ',
	'vehicleImages.overviewPhotos.subtitle': 'ถ่ายรูปรถ',
	'vehicleImages.description':
		'ถ่ายภาพรถในแนวทแยงมุมด้านหน้าซ้ายและขวา ด้านหลังซ้ายและขวา ต้องเห็นป้ายทะเบียนทุกรูป',
	'vinPicture.headline': 'ภาพถ่ายพร้อมหมายเลข VIN (ตัวถัง) ที่มองเห็นได้',
	'imageRecognitionMismatchModal.headline': 'คุณแน่ใจหรือว่ารูปภาพที่เพิ่มถูกต้อง ?',
	'overallDashboardImage.headline': 'ภาพรวมรูปภาพแผงหน้าปัด',
	'review.stepDescription.mileage': 'ไมล์สะสม',
	'review.button.next': 'ถัดไป »',
	'feedback.headline': 'ขอบคุณสำหรับการใช้งาน EasyClaim',
	'feedback.headline.policyCheck': 'ได้รับรูปภาพเรียบร้อยแล้ว',
	'feedback.description':
		'ข้อมูลของคุณจะถูกอัปโหลด ขั้นตอนนี้อาจใช้เวลาหลายนาที ทั้งนี้ขึ้นอยู่กับการเชื่อมต่ออินเทอร์เน็ตของคุณ',
	'feedback.rating.policyCheck':
		'คุณจะจัดอันดับประสบการณ์การใช้แอปด้วยกี่ดาว โดย 5 เป็นคะแนนที่ดีที่สุด',
	'feedback.button.send': 'ส่งความคิดเห็น',
	'feedback.yourOpinion': 'แสดงความคิดเห็น',
	'upload.message':
		'ข้อมูลของคุณจะถูกอัปโหลด ขั้นตอนนี้อาจใช้เวลาหลายนาที ทั้งนี้ขึ้นอยู่กับการเชื่อมต่ออินเทอร์เน็ตของคุณ',
	'waitForAudit.thankYou': 'ขอขอบคุณสำหรับความคิดเห็นของคุณ',
	'waitforAudit.finish': 'เสร็จสิ้น',
	'waitForAudit.description': 'ขอบคุณที่ไว้วางใจ',
	'waitForAudit.description.damageFound': 'ขอบคุณที่ไว้วางใจ',
	'waitForAudit.description.damageNotFound': 'ขอบคุณที่ไว้วางใจ',
	'windshieldImage.headline': 'ภาพกระจกหน้ารถ',
	'loader.error': 'ไม่สามารถโหลดกระบวนการของคุณ กรุณาลองใหม่อีกครั้งในภายหลัง.',
	'mainError.tryAgain': 'ลองอีกครั้ง',
	'tutorialModal.headline.first.policyCheck': 'อะไรอยู่เบื้องหลัง PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck คือการตรวจสอบยานพาหนะอย่างรวดเร็ว ขั้นตอนการตรวจสอบประกอบด้วย 8 ขั้นตอนง่ายๆ',
	'tutorialModal.paragraph.second': ' ',
	'timeout.bottom': ' ',
	'thanks.headline.first': 'ขอบคุณ',
	'thanks.paragraph.first': 'ขอบคุณสำหรับการใช้งาน EasyClaim',
	'testcasemodal.headline': 'เคสทดสอบ',
	'testcasemodal.accept': 'ตกลง',
	'testcasemodal.paragraph': 'โปรดระวังนี่คือเคสทดสอบ',
	'testcasewarningalert.paragraph': 'โปรดระวังนี่คือเคสทดสอบ',

	'invalidFile.size.title': 'ขนาดภาพไม่ถูกต้อง',
	'invalidFile.size.description': 'ขนาดของภาพใหญ่กว่าขนาดสูงสุดที่กำหนดไว้',
	'invalidFile.extension.title': 'ไม่รองรับประเภทไฟล์',
	'invalidFile.extension.description':
		'ไม่รองรับประเภทไฟล์ที่ระบุ ประเภทไฟล์ที่รองรับ: .jpg, .jpeg, .jfif, .heic, .heif, .png และ .bmp',
};

export default messages;
